import { type ReactNode } from 'react';
import { Col, Row } from 'react-bootstrap';

export function MetadataElement({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  if (children === undefined) {
    return null;
  }

  return (
    <>
      <Row className="mt-2">
        <strong>{title}</strong>
      </Row>
      <Row>
        <Col>{children}</Col>
      </Row>
    </>
  );
}
